// client third party integration types
export const CLIENT_THIRD_PARTY_INTEGRATION_OAUTH_2_0_TYPE = 'oauth 2.0';
export const CLIENT_THIRD_PARTY_INTEGRATION_API_KEY_TYPE = 'apikey';
export const CLIENT_THIRD_PARTY_INTEGRATION_BASIC_TYPE = 'basic';
export const CLIENT_THIRD_PARTY_INTEGRATION_KOMBO_TYPE = 'kombo';



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/constants/global.ts